import Route from "vue-routisan";
import vuex from "src/vuex";
import isGuest from "./middlewares/isGuest";

Route.redirect("/", to => {
  // if (!vuex.getters.getToken) {
  return {name: "login"};
  // }

});
Route.group({},() =>{
  Route.group({prefix: "auth", beforeEnter: isGuest}, () => {
    Route.view("/login", () =>
      import(/* webpackChunkName: "auth" */ "src/resources/views/guest/Login.vue")
    )
      .name("login")
      .options({
        meta: {
          layout: () =>
            import(/* webpackChunkName: "guest" */ "src/resources/views/guest/layout/AuthLayout.vue")
        }
      });
    Route.view("/forgot_my_password", () =>
      import(/* webpackChunkName: "auth" */ "src/resources/views/guest/ForgotMyPassword.vue")
    )
      .name("forgot_my_password")
      .options({
        meta: {
          layout: () =>
            import(/* webpackChunkName: "guest" */ "src/resources/views/guest/layout/AuthLayout.vue")
        }
      });

    Route.view("/reset_password/:token", () =>
      import(/* webpackChunkName: "auth" */ "src/resources/views/guest/ResetPassword.vue")
    )
      .name("reset_password")
      .options({
        meta: {
          layout: () =>
            import(/* webpackChunkName: "guest" */ "src/resources/views/guest/layout/AuthLayout.vue")
        }
      });
  });

  Route.view("*", () =>
    import(/* webpackChunkName: "error" */ "src/resources/views/errors/NotFound.vue")
  )
    .name("not_found")
    .options({
      meta: {
        layout: () =>
          import(/* webpackChunkName: "guest" */ "src/resources/views/errors/partials/EmptyLayout.vue")
      }
    });

  Route.view("/finance/register/:code?", () =>
    import(/* webpackChunkName: "auth" */ "src/resources/views/guest/FinanceCreate.vue")
  )
    .name("finance_create")
    .options({
      meta: {
        layout: () =>
          import(/* webpackChunkName: "guest" */ "src/resources/views/guest/layout/FinanceLayout.vue")
      }
    });

  Route.view("/create_tms_user", () =>
    import(/* webpackChunkName: "auth" */ "src/resources/views/guest/TmsRegister.vue")
  )
    .name("create_tms_user")
    .options({
      meta: {
        layout: () =>
          import(/* webpackChunkName: "guest" */ "src/resources/views/guest/layout/AuthLayout.vue")
      }
    });

  Route.view("/verify/:id/:hash", () =>
    import(/* webpackChunkName: "auth" */ "src/resources/views/guest/VerifyEmail.vue")
  )
    .name("verify_email")
    .options({
      meta: {
        layout: () =>
          import(/* webpackChunkName: "guest" */ "src/resources/views/guest/layout/VerifyEmailLayout.vue")
      }
    });

  Route.view("/insert_password/:id/:hash/:onboarding?", () =>
    import(/* webpackChunkName: "auth" */ "src/resources/views/guest/InsertPassword.vue")
  )
    .name("insert_password")
    .options({
      meta: {
        layout: () =>
          import(/* webpackChunkName: "guest" */ "src/resources/views/guest/layout/AuthLayout.vue")
      }
    });

  Route.view("/customer/survey/:hash", () =>
    import(/* webpackChunkName: "auth" */ "src/resources/views/guest/FinalCustomerSurvey.vue")
  )
    .name("final_customer_survey")
    .options({
      meta: {
        layout: () =>
          import(/* webpackChunkName: "guest" */ "src/resources/views/guest/layout/FinalCustomerSurveyLayout.vue")
      }
    });
  Route.view("/manager/register", () =>
    import(/* webpackChunkName: "auth" */ "src/resources/views/guest/ShipperCreate.vue")
  )
    .name("manager_create")
    .options({
      meta: {
        layout: () =>
          import(/* webpackChunkName: "guest" */ "src/resources/views/guest/layout/FinanceLayout.vue")
      }
    });

});


export default Route.all();
